"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var mobx_react_1 = require("mobx-react");
var store_component_1 = __importDefault(require("@hikakaku/shared/components/estimate_form/common/store_component"));
var base_modal_1 = __importDefault(require("@hikakaku/shared/components/common/base_modal"));
var sms_verification_modal_1 = __importDefault(require("../common/sms_verification_modal"));
var SMS_VERIFICATION_TOKEN_FIELD_NAME = 'estimate_form[sms_verification_token]';
var EstimateForm = (0, mobx_react_1.observer)(function (_a) {
    var store = _a.store;
    var _b = (0, react_1.useState)(null), kaitoriBonus = _b[0], setKaitoriBonus = _b[1];
    (0, react_1.useEffect)(function () {
        var urlParams = new URLSearchParams(window.location.search);
        var kaitoriParam = urlParams.get('kaitori_bonus_campaign_id');
        if (kaitoriParam) {
            setKaitoriBonus(kaitoriParam);
        }
        else if (store.kaitoriBonusCampaignId) {
            setKaitoriBonus(store.kaitoriBonusCampaignId.toString());
        }
    }, [store.kaitoriBonusCampaignId]);
    // SNSログイン後、自動でユーザー情報入力ステップまで1ステップずつ進める（client-sideで実行）
    (0, react_1.useEffect)(function () {
        var _a;
        (_a = store.autoProceedAfterSnsLogin) === null || _a === void 0 ? void 0 : _a.call(store);
    }, [store]);
    var handleSmsVerified = (0, react_1.useCallback)(function () {
        // Add SMS verification token to hidden fields
        if (store.smsVerificationStore.token && store.hiddenFieldInputListStore) {
            store.hiddenFieldInputListStore.replaceHiddenField({
                name: SMS_VERIFICATION_TOKEN_FIELD_NAME,
                value: store.smsVerificationStore.token
            });
        }
        // Defer submit to the next event loop tick to ensure all state updates are processed
        setTimeout(function () {
            if (store.formRef.current) {
                store.isSending = true;
                store.removeBeforeUnloadEvent();
                store.formRef.current.submit();
            }
        }, 0);
    }, [store]);
    var title = (react_1.default.createElement("span", { className: "duplicateItemModal__title-text" }, "\u3054\u78BA\u8A8D"));
    var content = (react_1.default.createElement("span", { className: "duplicateItemModal__content-text" },
        "\u540C\u69D8\u306E\u7533\u8FBC\u304C\u904E\u53BB24\u6642\u9593\u4EE5\u5185\u306B\u3042\u308A\u307E\u3057\u305F",
        react_1.default.createElement("br", null),
        "\u518D\u5EA6\u540C\u69D8\u306E\u7533\u8FBC\u3092\u884C\u3044\u305F\u3044\u5834\u5408\u3001\u304A\u554F\u3044\u5408\u308F\u305B\u30D5\u30A9\u30FC\u30E0\u307E\u3067\u3054\u76F8\u8AC7\u304F\u3060\u3055\u3044"));
    var footer = (react_1.default.createElement("button", { onClick: function () {
            var _a;
            (_a = store.handleModalButtonClick) === null || _a === void 0 ? void 0 : _a.call(store);
        }, className: "duplicateItemModal__footer-button" },
        react_1.default.createElement("p", { className: "duplicateItemModal__footer-buttonText" }, "\u304A\u554F\u3044\u5408\u308F\u305B\u3078")));
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("form", { action: store.postUrl, ref: store.formRef, method: "post", encType: "multipart/form-data" },
            kaitoriBonus && (react_1.default.createElement("input", { type: "hidden", name: "estimate_form[kaitori_bonus_campaign_id]", value: kaitoriBonus })),
            store.fixedComponentStores && store.fixedComponentStores.map(function (store, idx) { return (react_1.default.createElement(store_component_1.default, { key: idx, store: store })); }),
            store.pageStores.map(function (store, idx) { return (react_1.default.createElement(store_component_1.default, { key: idx, store: store })); })),
        react_1.default.createElement(base_modal_1.default, { isOpen: store.isModalOpen, onClose: store.handleModalClose, title: title, content: content, footer: footer, headerClassName: "duplicateItemModal__title", bodyClassName: "duplicateItemModal__content", footerClassName: "duplicateItemModal__footer", closeIconClassName: "duplicateItemModal__close-button", modalClassName: "duplicateItemModal" }),
        react_1.default.createElement(sms_verification_modal_1.default, { store: store.smsVerificationStore, onVerified: handleSmsVerified })));
});
exports.default = EstimateForm;
